<template>
  <div class="tags-view-container">
    <ScrollPane class='tags-view-wrapper' ref='scrollPane'>
      <router-link ref='tag' class="tags-view-item" :class="isActive(tag)? 'active':''" v-for="tag in Array.from(visitedViews)"
        :to="{path: tag.path, query: tag.query}" :key="tag.path">
        {{tag.title}}
        <span class='el-icon-close' @click.prevent.stop='closeSelectedTag(tag)'></span>
      </router-link>
    </ScrollPane>
  </div>
</template>

<script>
import ScrollPane from './scrollpane'
import { mapGetters, mapActions } from 'vuex'
export default {
  components: { ScrollPane },
  data () {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {}
    }
  },
  computed: {
    ...mapGetters([
      'visitedViews'
    ])
  },
  watch: {
    $route (val) {
      if (val.meta.admin) return
      this.addViewTags()
      this.moveToCurrentTag()
      this.delVisitedTags()
    },
    visible (value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted () {
    this.addViewTags()
  },
  methods: {
    ...mapActions([
      'addVisitedViews',
      'delVisitedViews',
      'unshiftVistedViews'
    ]),
    generateRoute () {
      if (this.$route.name) {
        return this.$route
      }
      return false
    },
    isActive (route) {
      return route.path === this.$route.path || route.name === this.$route.name
    },
    addViewTags () {
      const route = this.generateRoute()
      if (!route) {
        return false
      }
      if (route.path !== '/') {
        this.addVisitedViews(route)
      }
    },
    delVisitedTags () {
      this.unshiftVistedViews()
    },
    moveToCurrentTag () {
      const tags = this.$refs.tag
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag.$el)
            break
          }
        }
      })
    },
    closeSelectedTag (view) {
      this.delVisitedViews(view).then((views) => {
        if (this.isActive(view)) {
          const latestView = views.slice(-1)[0]
          if (latestView) {
            this.$router.push({path: latestView.path, query: latestView.query})
          } else {
            this.$router.push('/')
          }
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.tags-view-container {
  .tags-view-wrapper {
    // margin-bottom: 10px;
    // border-bottom: 2px solid #d8dce5;
    height: 30px;
    // border-bottom: 1px solid #d8dce5;
    .tags-view-item {
      display: inline-block;
      position: relative;
      height: 30px;
      line-height: 30px;
      // border: 1px solid #d8dce5;
      color: #495060;
      font-weight: 550;
      padding: 0 20px;
      font-size: 12px;
      margin-right: 2px;
      box-sizing: border-box;
      // margin-top: 2px;
      background-color: #fff;
      // margin-left: -1px;
      // border-top-right-radius: 6px;
      border-top-left-radius: 6px;
      &:first-of-type {
        // margin-left: 0;
        // border-top-left-radius: 6px;
      }
      &.active {
        background-color: #409eff;
        color: #fff;
        // border-color: #fff;
        border: none;
        // border-bottom: 2px solid #2a6bac;
        &::before {
          content: '';
          background: #fff;
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          position: relative;
          margin-right: 6px;
        }
      }
    }
  }
}
</style>

<style rel="stylesheet/scss" lang="scss">
//reset element css of el-icon-close
.tags-view-wrapper {
  // background-color: #157fcc;
  .tags-view-item {
    .el-icon-close {
      width: 16px;
      height: 16px;
      vertical-align: 0px;
      border-radius: 50%;
      text-align: center;
      transition: all .3s cubic-bezier(.645, .045, .355, 1);
      transform-origin: 100% 50%;
      position: relative;
      left: 8px;
      &:before {
        transform: scale(.6);
        display: inline-block;
        vertical-align: -1px;
      }
      &:hover {
        background-color: #b4bccc;
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/firmiana/layout/TagsViews/index.vue